export default {
  title: 'サプライチェーン管理',
  supplierList: 'サプライヤー一覧',
};
